var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2443_601",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7835 0.0205078H2.4702C1.62735 0.0205078 0.944092 0.647309 0.944092 1.42051V12.6205C0.944092 13.3937 1.62735 14.0205 2.4702 14.0205H20.7835C21.6264 14.0205 22.3096 13.3937 22.3096 12.6205V1.42051C22.3096 0.647309 21.6264 0.0205078 20.7835 0.0205078Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2443_601)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7835 0.0205078H2.4702C1.62735 0.0205078 0.944092 0.647309 0.944092 1.42051V12.6205C0.944092 13.3937 1.62735 14.0205 2.4702 14.0205H20.7835C21.6264 14.0205 22.3096 13.3937 22.3096 12.6205V1.42051C22.3096 0.647309 21.6264 0.0205078 20.7835 0.0205078Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2443_601",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7835 0.0205078H2.4702C1.62735 0.0205078 0.944092 0.647309 0.944092 1.42051V12.6205C0.944092 13.3937 1.62735 14.0205 2.4702 14.0205H20.7835C21.6264 14.0205 22.3096 13.3937 22.3096 12.6205V1.42051C22.3096 0.647309 21.6264 0.0205078 20.7835 0.0205078Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2443_601)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3096 0.0205078H0.944092V0.953839H22.3096V0.0205078ZM22.3096 1.88718H0.944092V2.82051H22.3096V1.88718ZM0.944092 3.75384H22.3096V4.68718H0.944092V3.75384ZM22.3096 5.62051H0.944092V6.55384H22.3096V5.62051ZM0.944092 7.4872H22.3096V8.42051H0.944092V7.4872ZM22.3096 9.35382H0.944092V10.2872H22.3096V9.35382ZM0.944092 11.2205H22.3096V12.1538H0.944092V11.2205ZM22.3096 13.0872H0.944092V14.0205H22.3096V13.0872Z",
    fill: "#D02F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1008 0.0205078H0.944092V6.55384H10.1008V0.0205078Z",
    fill: "#46467F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2443_601)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.97908 1.42028C2.97908 1.67801 2.75133 1.88694 2.47038 1.88694C2.18943 1.88694 1.96167 1.67801 1.96167 1.42028C1.96167 1.16255 2.18943 0.953613 2.47038 0.953613C2.75133 0.953613 2.97908 1.16255 2.97908 1.42028ZM5.01389 1.42028C5.01389 1.67801 4.78614 1.88694 4.50519 1.88694C4.22424 1.88694 3.99649 1.67801 3.99649 1.42028C3.99649 1.16255 4.22424 0.953613 4.50519 0.953613C4.78614 0.953613 5.01389 1.16255 5.01389 1.42028ZM6.54 1.88694C6.82095 1.88694 7.04871 1.67801 7.04871 1.42028C7.04871 1.16255 6.82095 0.953613 6.54 0.953613C6.25905 0.953613 6.0313 1.16255 6.0313 1.42028C6.0313 1.67801 6.25905 1.88694 6.54 1.88694ZM9.08349 1.42028C9.08349 1.67801 8.85579 1.88694 8.57482 1.88694C8.29387 1.88694 8.06611 1.67801 8.06611 1.42028C8.06611 1.16255 8.29387 0.953613 8.57482 0.953613C8.85579 0.953613 9.08349 1.16255 9.08349 1.42028ZM3.48778 2.82028C3.76873 2.82028 3.99649 2.61135 3.99649 2.35361C3.99649 2.09588 3.76873 1.88694 3.48778 1.88694C3.20683 1.88694 2.97908 2.09588 2.97908 2.35361C2.97908 2.61135 3.20683 2.82028 3.48778 2.82028ZM6.0313 2.35361C6.0313 2.61135 5.80355 2.82028 5.5226 2.82028C5.24165 2.82028 5.01389 2.61135 5.01389 2.35361C5.01389 2.09588 5.24165 1.88694 5.5226 1.88694C5.80355 1.88694 6.0313 2.09588 6.0313 2.35361ZM7.55742 2.82028C7.83836 2.82028 8.06611 2.61135 8.06611 2.35361C8.06611 2.09588 7.83836 1.88694 7.55742 1.88694C7.27647 1.88694 7.04871 2.09588 7.04871 2.35361C7.04871 2.61135 7.27647 2.82028 7.55742 2.82028ZM9.08349 3.28694C9.08349 3.54468 8.85579 3.75361 8.57482 3.75361C8.29387 3.75361 8.06611 3.54468 8.06611 3.28694C8.06611 3.02921 8.29387 2.82028 8.57482 2.82028C8.85579 2.82028 9.08349 3.02921 9.08349 3.28694ZM6.54 3.75361C6.82095 3.75361 7.04871 3.54468 7.04871 3.28694C7.04871 3.02921 6.82095 2.82028 6.54 2.82028C6.25905 2.82028 6.0313 3.02921 6.0313 3.28694C6.0313 3.54468 6.25905 3.75361 6.54 3.75361ZM5.01389 3.28694C5.01389 3.54468 4.78614 3.75361 4.50519 3.75361C4.22424 3.75361 3.99649 3.54468 3.99649 3.28694C3.99649 3.02921 4.22424 2.82028 4.50519 2.82028C4.78614 2.82028 5.01389 3.02921 5.01389 3.28694ZM2.47038 3.75361C2.75133 3.75361 2.97908 3.54468 2.97908 3.28694C2.97908 3.02921 2.75133 2.82028 2.47038 2.82028C2.18943 2.82028 1.96167 3.02921 1.96167 3.28694C1.96167 3.54468 2.18943 3.75361 2.47038 3.75361ZM3.99649 4.22028C3.99649 4.47802 3.76873 4.68694 3.48778 4.68694C3.20683 4.68694 2.97908 4.47802 2.97908 4.22028C2.97908 3.96254 3.20683 3.75361 3.48778 3.75361C3.76873 3.75361 3.99649 3.96254 3.99649 4.22028ZM5.5226 4.68694C5.80355 4.68694 6.0313 4.47802 6.0313 4.22028C6.0313 3.96254 5.80355 3.75361 5.5226 3.75361C5.24165 3.75361 5.01389 3.96254 5.01389 4.22028C5.01389 4.47802 5.24165 4.68694 5.5226 4.68694ZM8.06611 4.22028C8.06611 4.47802 7.83836 4.68694 7.55742 4.68694C7.27647 4.68694 7.04871 4.47802 7.04871 4.22028C7.04871 3.96254 7.27647 3.75361 7.55742 3.75361C7.83836 3.75361 8.06611 3.96254 8.06611 4.22028ZM8.57482 5.62028C8.85579 5.62028 9.08349 5.41135 9.08349 5.15361C9.08349 4.89588 8.85579 4.68694 8.57482 4.68694C8.29387 4.68694 8.06611 4.89588 8.06611 5.15361C8.06611 5.41135 8.29387 5.62028 8.57482 5.62028ZM7.04871 5.15361C7.04871 5.41135 6.82095 5.62028 6.54 5.62028C6.25905 5.62028 6.0313 5.41135 6.0313 5.15361C6.0313 4.89588 6.25905 4.68694 6.54 4.68694C6.82095 4.68694 7.04871 4.89588 7.04871 5.15361ZM4.50519 5.62028C4.78614 5.62028 5.01389 5.41135 5.01389 5.15361C5.01389 4.89588 4.78614 4.68694 4.50519 4.68694C4.22424 4.68694 3.99649 4.89588 3.99649 5.15361C3.99649 5.41135 4.22424 5.62028 4.50519 5.62028ZM2.97908 5.15361C2.97908 5.41135 2.75133 5.62028 2.47038 5.62028C2.18943 5.62028 1.96167 5.41135 1.96167 5.15361C1.96167 4.89588 2.18943 4.68694 2.47038 4.68694C2.75133 4.68694 2.97908 4.89588 2.97908 5.15361Z",
    fill: "url(#paint0_linear_2443_601)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2443_601",
    x: 1.96167,
    y: 0.953613,
    width: 7.12183,
    height: 6.80936,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.14286
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2443_601"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2443_601",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2443_601",
    x1: 1.96167,
    y1: 0.953613,
    x2: 1.96167,
    y2: 5.62027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.cfe2b988ebc243bf55d789149b86b757.svg";
export { ForwardRef as ReactComponent };